import React from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import dynamic from 'next/dynamic';
import TwoBlogSec from '../Common/TwoBlogSec';

const TopView = dynamic(() => import('./TopView'), {
  ssr: true,
});

const FeaturesSection = dynamic(() => import('./FeaturesSection'), {
  ssr: true,
});
const SuccessStories = dynamic(() => import('./SuccessStories'), {
  ssr: true,
});

const FreQuestion = dynamic(() => import('./freQuestions/index'), {
  ssr: true,
});

const WhatWeCover = dynamic(() => import('./WhatWeCover'), {
  ssr: true,
});

const SectionWho = dynamic(() => import('./sectionWho'), {
  ssr: true,
});

const RemoveFakeAccountContent = ({ data }: { data: any }) => {
  return (
    <div>
      <CommonBackContent>
        <TopView />
      </CommonBackContent>
      {/*<InfoView />*/}
      <CommonBackContent>
        <FeaturesSection />
      </CommonBackContent>
      <WhatWeCover />
      <CommonBackContent>
        <SectionWho />
      </CommonBackContent>
      {data.contentInfo['section-testimonial'].title && (
        <SuccessStories data={data.contentInfo['section-testimonial']} />
      )}
      <CommonBackContent style={{ marginTop: '80px' }}>
        <TwoBlogSec
          blogList={data.blogList}
          topBlogList={data.topBlogList}
          blogTitle={data.contentInfo['section-blog']?.title}
          topBlogTitle={data.contentInfo['section-top-blog']?.title}
        />
      </CommonBackContent>
      <CommonBackContent>
        <FreQuestion data={data} />
      </CommonBackContent>
    </div>
  );
};

export default RemoveFakeAccountContent;
